import { lazyOperateContent, OperateContentType } from 'owa-editor';
import EditorViewState from 'owa-editor/lib/store/schema/EditorViewState';
import { OWA_INSERT_LINK_PLACEHOLDER_CLASSNAME } from './constants';

export async function getAllInsertLinksIds(editorViewState: EditorViewState): Promise<string[]> {
    const operateContent: OperateContentType = await lazyOperateContent.import();
    let allInsertLinks: HTMLElement[] = [];
    operateContent(editorViewState, (editor, range, domUtils) => {
        allInsertLinks = editor.queryElements('.' + OWA_INSERT_LINK_PLACEHOLDER_CLASSNAME);
        return {
            selectionRange: null,
            changeSource: null,
        };
    });

    return allInsertLinks.map(element => element.id);
}
